<h2 mat-dialog-title data-test="dialog">{{ data.title }}</h2>
<div mat-dialog-content>
  <agr-form [formGroup]="formGroup">
    <mat-form-field class="spacing--margin-top">
      <mat-label>{{ 'year' | translate }}</mat-label>
      <mat-select formControlName="yearControl" placeholder="{{ 'selectYear' | translate }}" data-test="select-year">
        @for (year of years; track year) {
          <mat-option [value]="year" data-test="years-item">
            {{ year }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="spacing--margin-bottom">
      <button type="button" mat-stroked-button (click)="file.click()" data-test="file-button">
        {{ selectedFile ? selectedFile.name : ('selectFile' | translate) }}
      </button>
    </div>
    <input hidden (change)="onFileSelected()" #file type="file" accept=".csv" data-test="file-input" />
  </agr-form>
</div>
<div mat-dialog-actions data-test="dialogButtons">
  <button
    mat-flat-button
    color="primary"
    [disabled]="!selectedFile || !formGroup.get('yearControl')?.value"
    (click)="confirm({ file: selectedFile, calendarYear: formGroup.get('yearControl')?.value })"
    data-test="dialog-submit"
  >
    {{ data.confirmButtonText }}
  </button>
  <button mat-stroked-button data-test="dialog-cancel" (click)="cancel()">
    {{ data.cancelButtonText }}
  </button>
</div>
